import { FeedbackCard } from '@/components/FeedbackCard';

/** The standalone route; the same card also appears under a served order. */
export default function Feedback() {
  return <FeedbackCard />;
}
